import { createSelector } from 'reselect';
import { OrderedMap, Set } from 'immutable';
import get from 'lodash/get';

import NewPaymentMethod from 'models/braintree/new-payment-method';

const readProp = (slice, key, defaultValue) => {
  if (!slice) {
    return defaultValue;
  }
  if (typeof slice.get === 'function') {
    const val = slice.get(key);
    return val !== undefined ? val : defaultValue;
  }
  return get(slice, key, defaultValue);
};

export const getPaymentMethodsState = state => get(state, 'paymentMethods', null);

export const selectPaymentMethods = getPaymentMethodsState;

export const getPaymentMethods = createSelector(
  [getPaymentMethodsState],
  paymentMethodsState => readProp(paymentMethodsState, 'paymentMethods', OrderedMap()),
);

export const getSelectedPaymentMethod = createSelector(
  [getPaymentMethodsState],
  paymentMethodsState => readProp(paymentMethodsState, 'selectedPaymentMethod', null),
);

export const getSelectedPaymentMethodId = createSelector(
  [getPaymentMethodsState],
  paymentMethodsState => readProp(paymentMethodsState, 'selectedPaymentMethodId', null),
);

export const getDefaultPaymentMethodId = createSelector(
  [getPaymentMethodsState],
  paymentMethodsState => readProp(paymentMethodsState, 'defaultPaymentMethodId', null),
);

export const getNewPaymentMethod = createSelector(
  [getPaymentMethodsState],
  paymentMethodsState => readProp(paymentMethodsState, 'newPaymentMethod', new NewPaymentMethod()),
);

export const getIsNewPayment = createSelector(
  [getPaymentMethodsState],
  paymentMethodsState => Boolean(readProp(paymentMethodsState, 'newPayment', false)),
);

export const getBraintreeToken = createSelector(
  [getPaymentMethodsState],
  paymentMethodsState => readProp(paymentMethodsState, 'braintreeToken', null),
);

export const getPaymentMethodsRequiredFields = createSelector(
  [getPaymentMethodsState],
  paymentMethodsState => readProp(paymentMethodsState, 'requiredFields', Set()),
);

export const getPaymentMethodsRequiredFieldErrors = createSelector(
  [getPaymentMethodsState],
  paymentMethodsState => readProp(paymentMethodsState, 'requiredFieldErrors', OrderedMap()),
);

export const getPaymentMethodsSubmitting = createSelector(
  [getPaymentMethodsState],
  paymentMethodsState => Boolean(readProp(paymentMethodsState, 'submitting', false)),
);

export const getPaymentMethodsShouldScrollToError = createSelector(
  [getPaymentMethodsState],
  paymentMethodsState => Boolean(readProp(paymentMethodsState, 'shouldScrollToError', false)),
);
